// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"f07c7599","631":"88d9c6e1","819":"da9028e6","982":"707f7ff5","997":"fc8c1ce3"}[chunkId] + ".chunk.js";
};